module.exports = __webpack_public_path__ + "e96a1f31eb5fa4de2429cf1bffc30c3b.jpg";